import { instance } from '../instance';

export const updateDingDingConfigs = (param) => instance.post('systemconfig/update', param);

export const listAllConfigs = (param) => instance.post('systemconfig/list', param);
